import { useSelector } from "react-redux";
import { Grid, Typography, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

import { useAxios } from "../../hooks/";
import pages from "../../constants/pages";
import {
  OuterBox,
  SubheaderSection,
  LoadingButton,
  ButtonContainer,
} from "./../../components";
import EventBookingSuccess from "./../Success/EventBookingSuccess";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";

export default function VideoPreview({ userData }) {
  const axios = useAxios({ baseURL: "mox_api_2" });

  const axiosDigipass = useAxios({
    baseURL: "digipass",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const queryParams = new URLSearchParams(location.search);

  const {
    appointmentData,
    matchPercentage,
    type,
    popup,
    docFace,
    clickPhotoURL,
  } = location.state || {};

  const bookingId = queryParams.get("booking_id");
  const visitorId = queryParams.get("visitor_id");
  const doc_face = queryParams.get("doc_face");
  const entityId = queryParams.get("entity_id");
  const userTypeId = queryParams.get("user_type_id");
  const popUp = queryParams.get("popup");
  const autoConsent = queryParams.get("auto_consent");
  const indepentent = queryParams.get("indepentent");

  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [livelinessError, setLivelinessError] = useState({});

  const [openSuccess, setOpenSuccess] = useState(false);
  const [displayMessage, setDisplayMessage] = useState("");
  const [success, setSuccess] = useState(false);

  function captureAgain() {
    const stream = document.querySelector("video")?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      document.querySelector("video").srcObject = null;
    }

    // Wait a short WDDWmoment to ensure stream is stopped before navigating
    setTimeout(() => {
      navigate(clickPhotoURL + "&from_preview=true", {
        state: {
          blob: "",
          blob2: "",
          matchPercentage: "",
          appointmentData,
          popup,
          clickPhotoURL,
          docFace,
        },
      });
    }, 300);
  }

  const checkingLiveliness = async () => {
    setLoading(true);

    const fileurl = userData.state.blob;
    const fileurl2 = userData.state.blob2;
    const userDocData = JSON.parse(
      localStorage.getItem(`userPayload_${visitorId}`)
    );

    axiosDigipass({
      url: `event/verify/booking`,
      method: "POST",
      disableRedirect: true,
      data: {
        name: " ",
        face_data: fileurl2.replace(/^data:image\/[a-z]+;base64,/, ""),

        aadhar_data: userDocData,

        phone_number: appointmentData.phone_number || visitorData.phoneNumber,
        ...(visitorId && {
          visitor_id: visitorId,
        }),
      },
    })
      .then((response) => {
        if (response.status) {
          // if (userTypeId == 5) {
          //   let key = visitorId;

          //   localStorage.setItem(key, response.data.encrypted_face_data);

          //   axiosDigipass({
          //     url: `hotel/booking/guest/verify`,
          //     method: "POST",
          //     disableRedirect: true,
          //     data: {
          //       booking_ref_id: bookingId,
          //       // booking_id: bookingId,
          //       hotel_id: hotelID,
          //       visitor_data: {
          //         visitor_id: visitor_id,
          //         booking_type: "event",
          //         ...userDocData,
          //       },
          //     },
          //   }).then((response) => {
          //     if (response.status) {
          //       navigate(pages.HotelSummary.path + hotelID + "/" + bookingId);
          //     }
          //   });
          // }
          let key = visitorId;

          localStorage.setItem(key, response.data.encrypted_face_data);

          if (!!popUp) {
            navigate(
              `${pages.Verification?.route}?visitor_id=${visitorId}&doc_face=true&booking_id=-1&entity_id=-1&user_type_id=0&popup=${popUp}`
            );
          } else if (bookingId == -1 && docFace == "true") {
            navigate(
              `${pages.Verification?.route}?visitor_id=${visitorId}&doc_face=true&booking_id=-1&entity_id=-1&user_type_id=${userTypeId}&doc_verify=true`
            );
          } else if (bookingId == -1) {
            setCountdown(5);
            const interval = setInterval(() => {
              setCountdown((prev) => {
                if (prev === 1) {
                  clearInterval(interval);
                }
                return prev - 1;
              });
            }, 1000);
            setSuccess(true);
          } else if (docFace == "true") {
            navigate(
              `${pages.Verification.route}?visitor_id=${
                visitorId || ""
              }&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&doc_face=${doc_face}&auto_consent=${autoConsent}${
                indepentent ? "&indepentent=" + indepentent : ""
              }`
            );
          } else {
            let key = visitorId;
            localStorage.setItem(key, response.data.encrypted_face_data);

            let url = "admin/profile/get-visitor-booking-status";

            let method = "POST";

            let data = {
              visitor_id: visitorId,
              entity_id: entityId,
              user_type_id: userTypeId,
              booking_id: bookingId,
              face_data: getVisitorFaceData(visitorId),
            };

            axios({
              url: url,
              disableRedirect: true,
              method: method,
              data: data,
            }).then((response) => {
              if (response.status) {
                let state = {
                  state: {
                    userData: response.data,
                    match_percentage: matchPercentage,
                    face_data: fileurl,
                  },
                };

                if (userTypeId == 1) {
                  navigate(
                    `${pages.EventSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                } else if (
                  userTypeId == 3 ||
                  userTypeId == 4 ||
                  userTypeId == 6
                ) {
                  navigate(
                    `${pages.CampusSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                } else if (userTypeId == 2) {
                  navigate(
                    `${
                      indepentent
                        ? pages.IndependentAppointmentSummary.route
                        : pages.AppointmentSummary.route
                    }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                } else if (userTypeId == 5) {
                  navigate(
                    `${pages.HotelSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                }
              }
            });
          }
        } else {
          setLivelinessError(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        console.error("Error in Aws upload:", error);
      });
  };

  useEffect(() => {
    if (countdown == 1) {
      navigate(pages.Profile.route);
    }
  }, [countdown]);

  return (
    <Fragment>
      {!success && (
        <Fragment>
          {" "}
          {livelinessError?.name_match !== undefined &&
          !livelinessError?.name_match &&
          !livelinessError?.face_match ? (
            <OuterBox>
              <SubheaderSection
                textAlign="center"
                title="Verification Failed"
              />

              <form>
                <Box>
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      padding: "10px",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <CancelRoundedIcon
                      sx={{
                        color: "red",
                        fontSize: "60px",
                        marginBottom: "15px",
                      }}
                    />
                    <Typography variant="h6" sx={{ color: "red" }}>
                      {livelinessError?.booking_already_verified
                        ? "Booking already verified"
                        : "Details Not Match"}
                      <br />
                    </Typography>
                  </Grid>
                </Box>

                <ButtonContainer>
                  <LoadingButton
                    onClick={() =>
                      navigate(
                        pages.Verification.route +
                          `?visitor_id=${visitorId}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}${
                            indepentent ? "&indepentent=" + indepentent : ""
                          }`
                      )
                    }
                  >
                    Try Again
                  </LoadingButton>
                </ButtonContainer>
              </form>
            </OuterBox>
          ) : (
            <Grid container flexDirection={"column"} style={{ height: "100%" }}>
              <Grid item sx={{ height: "100%" }}>
                <form style={{ height: "100%" }}>
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    sx={{ height: "100%", position: "relative" }}
                  >
                    <Grid
                      item
                      style={{
                        textAlign: "center",
                        height: "100%",
                      }}
                      className="videoBox"
                      position={"relative"}
                    >
                      <img
                        id="video"
                        // width="100%"
                        // height="100%"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "fill",
                          borderRadius: "0px",
                          transform: "scaleX(-1)",
                          display: "block", // prevents inline-gap issues
                          WebkitObjectFit: "cover", // iOS Safari support
                        }}
                        src={userData?.state?.blob}
                        alt="Preview"
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      display={"flex"}
                      justifyContent={"center"}
                      style={{
                        position: "absolute",
                        bottom: "40px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                    </Grid>

                    <div
                      style={{
                        position: "absolute",
                        bottom: "0px",
                        // width: "85%",
                      }}
                    >
                      <Typography
                        variant="h5"
                        style={{
                          fontWeight: "900",
                          color: "white",
                          margin: "5px 0px",
                          textAlign: "center",
                        }}
                      >
                        Face Verification
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          fontWeight: "900",
                          color: "white",
                          margin: "5px 0px",
                          textAlign: "center",
                        }}
                      >
                        Before proceeding, check the image preview
                      </Typography>

                      {!Boolean(livelinessError?.name_match) && (
                        <LoadingButton
                          loading={loading}
                          className="proceedNextBtn"
                          onClick={checkingLiveliness}
                          style={{ marginTop: "5px", boxShadow: "none" }}
                        >
                          Proceed Next
                        </LoadingButton>
                      )}

                      <LoadingButton
                        onClick={captureAgain}
                        disabled={loading}
                        className="captureAgainBtn"
                        backgroundColor="rgb(254 241 212)"
                        style={{
                          margin: "10px 0px",
                          boxShadow: "none",
                          color: "black",
                        }}
                      >
                        Capture Again
                      </LoadingButton>
                    </div>
                  </Box>
                </form>
              </Grid>
            </Grid>
          )}
        </Fragment>
      )}

      {success && (
        <Fragment>
          <Grid
            container
            sx={{
              width: "100%",
              height: "100%",
              background: "#1B996A",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="89"
              height="89"
              viewBox="0 0 89 89"
              fill="none"
            >
              <path
                d="M13.3335 30.5185V20.6667C13.3335 16.0029 17.1142 12.2222 21.7779 12.2222H31.1607"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
              <path
                d="M13.3335 57.7286V67.5804C13.3335 72.2442 17.1142 76.0249 21.7779 76.0249H31.1607"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
              <path
                d="M76.667 30.5185V20.6667C76.667 16.0029 72.8863 12.2222 68.2225 12.2222H58.8398"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
              <path
                d="M76.667 57.7286V67.5804C76.667 72.2442 72.8863 76.0249 68.2225 76.0249H58.8398"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
              <path
                d="M55.5559 57.5553L54.146 58.182C48.3235 60.7697 41.6772 60.7697 35.8547 58.182L34.4448 57.5553"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
              <path
                d="M46.3951 34.0986V45.6709C46.3951 47.4435 45.1549 48.9745 43.4208 49.3423L41.9507 49.6541"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
              <path
                d="M31.6299 34.0986L31.6299 39.6541"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
              <path
                d="M58.8398 34.0986L58.8398 39.6541"
                stroke="white"
                stroke-width="3.33333"
                stroke-linecap="round"
              />
            </svg>
            <Typography
              variant="h4"
              style={{
                fontWeight: "900",
                color: "white",
                margin: "10px 0px",
              }}
            >
              {countdown}
            </Typography>
            <Typography
              variant="h4"
              style={{
                fontWeight: "900",
                color: "white",
                margin: "10px 0px",
              }}
            >
              Face Verification Successful
            </Typography>

            <Typography
              variant="body1"
              style={{
                fontWeight: "400",
                color: "#FFFFFFB2",
              }}
            >
              Your profile is now verified
            </Typography>
          </Grid>
        </Fragment>
      )}

      <EventBookingSuccess
        open={openSuccess}
        setOpen={setOpenSuccess}
        SuccessMessage={displayMessage}
      />
    </Fragment>
  );
}
